import { DailyLogDetailContent } from "@features/daily-log-detail/ui/DailyLogDetailContent";
import { resolveDailyLogSearchReturn } from "@features/project-detail/model/dailyLogSearchNavigation";
import { invalidateDailyLogSearch } from "@features/project-detail/model/dailyLogSearchQueries";
import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate, useRouter, useRouterState } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/projects/$projectId/log/$logId/")({
  component: DailyLogDetailPage,
});

function DailyLogDetailPage() {
  const { projectId, logId } = Route.useParams();
  const router = useRouter();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const locationState = useRouterState({ select: (state) => state.location.state });

  // 검색 목록에서 들어왔으면 원래 목록 history entry로 돌아가 보던 위치를 복원한다.
  // 홈·Work History 등 앱 안의 다른 화면에서 들어왔으면 직전 화면으로 돌아간다.
  // 직접 열기·새 탭은 앱 안의 이전 화면이 없으므로 이 프로젝트의 Documents로 간다.
  const handleClose = () => {
    const destination = resolveDailyLogSearchReturn(locationState, projectId);
    if (destination.kind === "history") {
      router.history.go(destination.delta);
      return;
    }
    if (destination.kind === "back") {
      router.history.back();
      return;
    }
    navigate({
      to: "/projects/$projectId",
      params: { projectId },
      search: { tab: "documents", ...destination.search },
      replace: true,
    });
  };

  return (
    <DailyLogDetailContent
      projectId={projectId}
      logId={logId}
      onClose={handleClose}
      editNavigationState={{ dailyLogSearchReturn: locationState.dailyLogSearchReturn }}
      onDeleted={() => invalidateDailyLogSearch(queryClient, projectId)}
    />
  );
}
